// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styles */
.container {
  font-family: Arial, sans-serif;
  color: #395e65;
  background-color: #fff066;
  z-index : 10;
}

/* Form styles */
.form-control {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  z-index : 10;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  z-index : 10;
}

.form-label {
  padding : 15;
  margin : 10rem;
  font-weight: bold;
  margin-bottom: 2.5rem;
}


/* Responsive styles */
@media (max-width: 767px) {
  .form-control {
    font-size: 0.9rem;
    padding: 0.5rem 0.75rem;
  }

  .btn {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Form.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":["/* General styles */\r\n.container {\r\n  font-family: Arial, sans-serif;\r\n  color: #395e65;\r\n  background-color: #fff066;\r\n  z-index : 10;\r\n}\r\n\r\n/* Form styles */\r\n.form-control {\r\n  padding: 0.75rem 1rem;\r\n  font-size: 1rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0.25rem;\r\n  z-index : 10;\r\n}\r\n\r\n.form-control:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\r\n  z-index : 10;\r\n}\r\n\r\n.form-label {\r\n  padding : 15;\r\n  margin : 10rem;\r\n  font-weight: bold;\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n\r\n/* Responsive styles */\r\n@media (max-width: 767px) {\r\n  .form-control {\r\n    font-size: 0.9rem;\r\n    padding: 0.5rem 0.75rem;\r\n  }\r\n\r\n  .btn {\r\n    font-size: 0.9rem;\r\n    padding: 0.5rem 1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
